import { forwardRef, type Ref, type SVGProps } from "react";

function SvgSearchFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M3 11a8 8 0 1 1 14.32 4.906L21.414 20 20 21.414l-4.094-4.094A8 8 0 0 1 3 11"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgSearchFilled);
export default ForwardRef;
